export default __webpack_public_path__ + "static/media/placeholder_dummy2016-reiseblog01-de.44790dcd.png";